<template>
  <div class="tasklist">
    <el-row>
      <el-col :span="24">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>Task</el-breadcrumb-item>
          <el-breadcrumb-item>Task List</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <h1>Task List</h1>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="searchs">
          <div class="searchs-item" style="width: 514px">
            <div class="searchs-item-title" style="width: 170px">
              Process Serial Number
            </div>
            <div class="searchs-item-control" style="width: 280px">
              <el-input
                v-model="searchKey.processSerialNumber"
                placeholder="Process Serial Number"
                :clearable="true"
              ></el-input>
            </div>
          </div>
          <div class="searchs-item" style="width: 514px">
            <div class="searchs-item-title" style="width: 152px">Process Name</div>
            <div class="searchs-item-control" style="width: 300px">
              <el-select v-model="model" placeholder="Process Name">
                <el-option label="合同销售确认申请" value="1"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="searchs-item" style="width: 320px">
            <div class="searchs-item-title" style="width: 160px">Process Status</div>
            <div class="searchs-item-control" style="width: 200px">
              <el-select v-model="searchKey.unit" placeholder="Process Status">
                <el-option label="Submit" value="Submit"> </el-option>
                <el-option label="Approving" value="Approving"> </el-option>
                <el-option label="Complete" value="Complete"> </el-option>
              </el-select>
            </div>
          </div>
          <div class="searchs-item" style="width: 185px">
            <div class="searchs-item-title" style="width: 23px"></div>
            <div class="searchs-item-control" style="width: 100px">
              <el-button type="primary" @click="search">Search</el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="NewOrder">
          + New Application
        </el-button></el-col
      >
    </el-row>
    <el-row>
      <el-col :span="24">
        <div style="display: flex">
          <div style="line-height: 2.5rem; width: 50%">
            No.of Records: {{ reportPagination.total }}
          </div>
          <div style="width: 50%" class="text-right">
            <el-pagination
              v-model:currentPage="reportPagination.pageIndex"
              layout="prev, pager, next"
              :total="reportPagination.total"
              :page-size="20"
              @current-change="search"
              @prev-change="search"
              @next-change="search"
            >
            </el-pagination>
          </div>
        </div>

        <el-table :data="tasklist" style="width: 100%" border>
          <el-table-column prop="processSerialNumber" label="Process Serial Number">
            <template #default="scope">
              <div>
                <el-link href="#" type="primary">
                  {{ scope.row.processSerialNumber }}
                </el-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="processName" label="Process Name"> </el-table-column>
          <el-table-column prop="processStatus" label="Process Status"> </el-table-column>
          <el-table-column prop="createByName" label="Create By Name"> </el-table-column>
          <el-table-column
            prop="createByName"
            label="Create By Date"
            :formatter="formatterCellDate"
          >
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { formatterCellDate } from "@/assets/js/formatter";

const searchKey = ref({});

const tasklist = ref([
  {
    processSerialNumber: "B000000001",
    processName: "合同销售确认申请",
    processStatus: "Approving",
    createByName: "2022-09-26",
  },
]);

const reportPagination = ref({
  total: 1,
  pageIndex: 1,
  pageSize: 20,
});
</script>

<style scoped>
.tasklist {
  font-size: 13px;
}
.searchs {
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
}
.searchs-item {
  line-height: 2.1rem;
  display: flex;
}

.searchs-item .searchs-item-control {
  padding: 0 50px 0 10px;
}

.filter-cell {
  height: 32px;
}

.filter-cell-title {
  padding: 5px 0;
}

.filter-cell-icon {
  position: absolute;
  top: 0;
  right: 12px;
}
.filter-cell-control {
  min-width: 230px;
}
.el-pagination {
  float: right;
}
</style>
